<template>
    <button class="btn btn-outline-gray btn-sm is-border-1" @click="exportFile">
        <i class="fa fa-download icon-left"></i> Xuất dữ liệu
        <b-modal v-model="exporting" title="Đang tải dữ liệu" @close="close" no-close-on-esc no-close-on-backdrop no-enforce-focus>
            <div class="alert alert-warning">
                <b-spinner small variant="primary"></b-spinner>&nbsp;
                <span>Dữ liệu đang được tải xuống! Xin vui lòng đợi trong giây lát và xin đừng tắt cửa sổ này cho đến khi quá trình tải xuống hoàn tất.</span>
                {{downloadedCount}} - {{totalCount}}
                <b-progress :max="totalCount">
                    <b-progress-bar :value="downloadedCount" :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
                </b-progress>
            </div>
        </b-modal>
    </button>
</template>

<script>
    import Export from "@/mixins/Export";
    import moment from 'moment';
    export default {
        props: ['filter', 'totalCount', 'params'],
        mixins: [Export],
        data() {
            let headers = [
                {header: 'client_id', key: 'client_id',label: 'Đơn vị', width: 30},
                {header: 'licensing', key: 'licensing', label: 'Loại giấy phép', width: 30},
                {header: 'licensing_number', key: 'licensing_number', label: 'Số giấy phép', width: 30},
                {header: 'start_time', key: 'start_time', label: 'Ngày cấp phép', width: 15},
                {header: 'end_time', key: 'end_time', label: 'Ngày hết hạn cấp phép', width: 25},
                {header: 'org_licensing', key: 'org_licensing', label: 'Cơ quan cấp phép', width: 25},
            ];
            return {
                service: '/environment-licensing',
                fileName: `quan-ly-cap-phep`,
                headers,
            }
        },
        methods: {
            setupSheet: async function (sheet) {
                let cols = [];
                let row = {};
                for (let i in this.headers) {
                    let header = this.headers[i];
                    cols.push(header);
                    row[header.key] = header.label;
                }
                sheet.columns = cols;
                await sheet.addRow(row);
                row = {};
                row["client_id"] = "Text"
                row["licensing"] = "Text"
                row["licensing_number"] = "Text";
                row["start_time"] = "Date (dd/mm/yyyy)";
                row["end_time"] = "Date (dd/mm/yyyy)";
                row["org_licensing"] = "Text";
                sheet.addRow(row);
                row.alignment = {wrapText: true};
                //ẩn dòng 1
                sheet.getRow(1).hidden = true;
                sheet.getRow(1).alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                sheet.getRow(1).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: {
                        argb: 'bdbdbd'
                    }
                };

                // đôi đậm và wrap text
                sheet.getRow(2).alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                sheet.getRow(2).font = {
                    bold: true
                };
                //bôi màu
                sheet.getRow(2).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: {
                        argb: '92D050'
                    }
                };
                //Dòng 3
                sheet.getRow(3).hidden = true;
                sheet.getRow(3).alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                sheet.getRow(3).font = {
                    italic: true
                };
            },
            addRow(item, params) {
                let row = {
                    client_id: params.client[item.client_id] && params.client[item.client_id].name ? params.client[item.client_id].name.toString() : '',
                    licensing: item.licensing ? item.licensing.toString() : '',
                    licensing_number: item.licensing_number ? item.licensing_number.toString() : '',
                    start_time: item.start_time > 0 ? moment(item.start_time * 1000).format('DD/MM/YYYY') : '',
                    end_time: item.end_time > 0 ? moment(item.end_time * 1000).format('DD/MM/YYYY') : '',
                    org_licensing: item.org_licensing ? item.org_licensing.toString() : '',
                };
                return row;
            },
        }
    }
</script>